import f from "../../funcs";
import Events from "../Events";
import UIModal from "../modals/UIModal";


export default Events.extend("AppError", {
    init(params) {
        params = params || {};

        for (let key in params) {
            this[key] = params[key];
        }

        if ( f.isFunction(this.onInit) ) {
            this.onInit(params);
        }
    },

    show() {
        UIModal.error(this.message);
    }
});
